import { StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { BaseStore } from '../base/base.store';

@Injectable({ providedIn: 'root' })
@StoreConfig({
    name: 'article-type',
    cache: {
        ttl: 15000
    }
})
export class ArticleTypeStore extends BaseStore {
    constructor() {
        super();
    }
}
